import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import DataTable from "examples/Tables/DataTable";
import init from "Helpers/WindowToken";
import EditIcon from "@mui/icons-material/Edit";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link } from "react-router-dom";
import { Card, Grid, Tooltip, IconButton, Switch } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

export default class SubjectsList extends Component {
  state = {
    subjects: [],
    per_page: 10,
    page_no: 1,
    pagination: {
      page: 1,
      totalPages: 1,
      hasNextPage: false,
      hasPrevPage: false,
      totalDocs: 0,
      limit: 10,
    },
    notification: false,
    message: "",
    notiColor: "success",
    loading: false,
  };

  componentDidMount() {
    this.getAllSubjects(this.state.page_no, this.state.per_page);
  }

  // ✅ FETCH SUBJECTS (POST)
  getAllSubjects = async (page = 1, limit = 10) => {
    this.setState({ loading: true });

    if (init() !== "success") return;

    try {
      const resp = await axios.post(
        Constants.getUrls.getAllSubjects,
        { page, limit }
      );

      if (resp.data.status) {
        const data = resp.data.data || {};
        const rows = data.rows || [];

        const pagination = {
          page: data.pagination?.currentPage || page,
          limit: data.pagination?.limit || limit,
          totalDocs: data.pagination?.total || rows.length,
          totalPages: data.pagination?.totalPages || 1,
          hasNextPage: data.pagination?.hasNextPage,
          hasPrevPage: data.pagination?.hasPrevPage,
        };

        this.setState({
          subjects: rows,
          pagination,
          loading: false,
        });
      } else {
        this.setState({
          notification: true,
          message: resp.data.message,
          notiColor: "warning",
          loading: false,
        });
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  // ✅ DELETE
  handleDelete = async (id) => {
    if (!window.confirm("Delete this subject?")) return;

    try {
      const resp = await axios.post(
        Constants.deleteUrls.deleteSubject,
        { id }
      );

      this.setState({
        notification: true,
        message: resp.data.message || "Deleted",
        notiColor: "success",
      });

      this.getAllSubjects(
        this.state.pagination.page,
        this.state.per_page
      );
    } catch (err) {
      this.setState({
        notification: true,
        message: "Delete failed!",
        notiColor: "warning",
      });
    }
  };

  // ✅ STATUS TOGGLE
  handleStatusChange = async (id, currentStatus) => {
    if (init() !== "success") return;

    const newStatus = currentStatus === "1" ? "0" : "1";

    try {
      const resp = await axios.post(
        Constants.putUrls.changeSubjectStatus,
        { id, status: newStatus }
      );

      if (resp.data.status) {
        this.setState({
          notification: true,
          message: resp.data.message || "Status updated",
          notiColor: "success",
        });

        this.getAllSubjects(
          this.state.pagination.page,
          this.state.per_page
        );
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Status update failed!",
        notiColor: "warning",
      });
    }
  };

  handlePageChange = (page) => {
    this.getAllSubjects(page, this.state.per_page);
  };

  handleEntriesPerPageChange = (limit) => {
    this.setState({ per_page: limit }, () => {
      this.getAllSubjects(1, limit);
    });
  };

  render() {
    const { subjects, pagination, loading } = this.state;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Subjects List
              </MDTypography>
            </MDBox>

             <Grid item sm={4} px={2} align="right">
                          <Link to="/addsubjects">
                            <MDButton variant="contained" size="small" color="primary">
                              Create New
                            </MDButton>
                          </Link>
                        </Grid>

            <MDBox py={3}>
              {loading ? (
                <Grid align="center">
                  <h4>Loading...</h4>
                </Grid>
              ) : subjects.length > 0 ? (
                <DataTable
                  table={{
                    columns: [
                      { Header: "S.No", accessor: "serial" },
                      { Header: "Subject", accessor: "subject_name" },
                      { Header: "Course", accessor: "course_name" },
                      { Header: "Level", accessor: "level_name" },
                      { Header: "Team", accessor: "team_name" },
                      { Header: "Status", accessor: "status" },
                      { Header: "Actions", accessor: "action" },
                    ],
                    rows: subjects.map((item, index) => ({
                      serial:
                        (pagination.page - 1) * pagination.limit +
                        (index + 1),

                      subject_name: item.subject_name,
                      course_name: item.course_name,
                      level_name: item.level_name,
                      team_name: item.team_name,

                      status: (
                        <Switch
                          checked={item.status === "1"}
                          onChange={() =>
                            this.handleStatusChange(
                              item.id,
                              item.status
                            )
                          }
                          color="success"
                        />
                      ),

                      action: (
                        <>
                         <Tooltip title="Edit">
                            <Link to={`/updatesubject/${item.id}`}>
                              <IconButton color="info">
                                <EditIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>
                        <Tooltip title="Delete">
                          <IconButton
                            color="error"
                            onClick={() =>
                              this.handleDelete(item.id)
                            }
                          >
                            <DeleteIcon />
                          </IconButton>
                        </Tooltip>
                        </>
                      ),
                    })),
                  }}
                  entriesPerPage={{ defaultValue: this.state.per_page }}
                  page_no={pagination.page}
                  totalPages={pagination.totalPages}
                  hasNextPage={pagination.hasNextPage}
                  hasPrevPage={pagination.hasPrevPage}
                  onPageChange={this.handlePageChange}
                  onEntriesPerPageChange={
                    this.handleEntriesPerPageChange
                  }
                />
              ) : (
                <div style={{ padding: 20 }}>No Subjects Found!</div>
              )}
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              title="Subjects"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}